import { Divider, Grid, Typography, Avatar, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { selectRoutineItemInsUpd } from "../../../redux/routine/routineItemInsUpdSlice";
import { assertImagesUrl } from "../../../redux/common";

export function RoutineItemInsUpdReview() {
    const routineItemInsUpd = useSelector(selectRoutineItemInsUpd);

    console.log("Reviewing routine item:", routineItemInsUpd.routineItem);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
                <Divider orientation="horizontal" flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{routineItemInsUpd.routineItem.name}</Typography>
                <Divider orientation="horizontal" flexItem />
            </Grid>

            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Ordem</Typography>
                <Divider orientation="horizontal" flexItem />
            </Grid>
            <Grid size={4}>
                <Typography component="div" variant="body1" color="darkblue">{routineItemInsUpd.routineItem.order ?? "-"}</Typography>
                <Divider orientation="horizontal" flexItem />
            </Grid>
            <Grid size={6}>
                <Typography component="div" variant="body1" color="darkgray" align="right"></Typography>
            </Grid>

            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Avatar</Typography>
            </Grid>
            <Grid size={6}>
                <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                    <Avatar
                        src={assertImagesUrl(routineItemInsUpd.routineItem.url)}
                        alt={routineItemInsUpd.routineItem.name}
                        sx={{ width: 40, height: 40, border: "1px solid #ccc" }}
                    />
                </Box>
            </Grid>
        </Grid>
        <Divider flexItem />
    </>;
}